import { moduleTypeInfo } from '../GlobalCache';
class GlobalCacheSwitchModule {
    constructor(address, portCount) {
        this.address = address;
        this.portCount = portCount;
        this.subType = 'hdmi-3-1';
        this.type = 'switch';
        this.state = 1;
    }
    getState(port) {
        return port === this.state;
    }
    setState(port) {
        this.state = port;
    }
}
class GlobalCacheRelayModule {
    constructor(address, portCount) {
        this.address = address;
        this.portCount = portCount;
        this.type = 'relay';
        this.state = [];
        for (let i = 0; i < portCount; i++)
            this.state.push(false);
    }
    getState(port) {
        var _a;
        return (_a = this.state[port - 1]) !== null && _a !== void 0 ? _a : false;
    }
    setState(port, value) {
        this.state[port - 1] = value;
    }
}
export class GlobalCache {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.modules = [];
        this.asyncHandlers = [
            {
                regExp: /^get_NET,(\d+):(\d+)$/,
                callback: (match) => {
                    const moduleAddress = parseInt(match[1], 10);
                    const port = parseInt(match[2], 10);
                    const module = this.getModule(moduleAddress, port, 'ethernet');
                    if (!module) {
                        this.socket.send(`ERR_0:0,001`);
                        return;
                    }
                    const ipAddress = '192.168.1.100';
                    const netmask = '255.255.255.0';
                    const gateway = '192.168.1.1';
                    this.socket.send(`NET,${moduleAddress}:${port},UNLOCKED,DHCP,${ipAddress},${netmask},${gateway}`);
                },
            },
            {
                regExp: /^getdevices$/,
                callback: (match) => {
                    for (const module of this.modules) {
                        let found = false;
                        for (const [externalType, internalType] of Object.entries(moduleTypeInfo)) {
                            if (internalType.type === module.type &&
                                internalType.subType === module.subType) {
                                const address = module.address;
                                // Ethernet module reports port count as 0.
                                const portCount = module.type === 'ethernet' ? 0 : module.portCount;
                                const type = externalType.toUpperCase();
                                this.socket.send(`device,${address},${portCount} ${type}`);
                                found = true;
                            }
                        }
                        if (!found) {
                            this.log.warning(`unhandled module: type = ${module.type}, subType = ${module.subType}`);
                        }
                    }
                    this.socket.send('endlistdevices');
                },
            },
            {
                regExp: /^getstate,(\d+):(\d+)$/,
                callback: (match) => {
                    const moduleAddress = parseInt(match[1], 10);
                    const port = parseInt(match[2], 10);
                    const module = this.getModule(moduleAddress, port);
                    if (!module || (module.type !== 'relay' && module.type !== 'switch')) {
                        this.socket.send(`ERR_0:0,001`);
                        return;
                    }
                    if (port > module.portCount) {
                        this.socket.send(`ERR_1:0,003`);
                        return;
                    }
                    this.socket.send(`state,${moduleAddress}:${port},${module.getState(port) ? '1' : '0'}`);
                },
            },
            {
                regExp: /^getversion$/,
                callback: (match) => {
                    const firmwareVersion = '710-1009-05';
                    this.socket.send(firmwareVersion);
                },
            },
            {
                regExp: /^setstate,(\d+):(\d+),([01])$/,
                callback: (match) => {
                    const moduleAddress = parseInt(match[1], 10);
                    const port = parseInt(match[2], 10);
                    const value = match[3] === '1';
                    const module = this.getModule(moduleAddress, port, 'relay');
                    if (!module) {
                        this.socket.send(`ERR_0:0,001`);
                        return;
                    }
                    module.setState(port, value);
                    this.socket.send(`setstate,${moduleAddress}:${port},${module.getState(port) ? '1' : '0'}`);
                },
            },
            {
                regExp: /.+/,
                callback: (match) => {
                    this.socket.send(`ERR_0:0,001`);
                },
            },
        ];
    }
    getModule(moduleAddress, port, moduleType) {
        return this.modules.find(module => moduleAddress === module.address &&
            port >= 1 &&
            port <= module.portCount &&
            (moduleType === undefined || moduleType === module.type));
    }
    onConfigure(config) {
        // If there are contact closures and/or video inputs defined in the config, then create
        // modules that match the addresses in those configs. If nothing is defined in the config,
        // then create a relay module. Try to keep existing modules and their states if possible.
        var _a, _b, _c;
        const newModules = [
            { address: 0, portCount: 1, type: 'ethernet' },
        ];
        for (const contactClosureConfig of Object.values((_a = config.contactClosures) !== null && _a !== void 0 ? _a : {})) {
            if ('moduleAddress' in contactClosureConfig &&
                !newModules.some(m => m.address === contactClosureConfig.moduleAddress)) {
                newModules.push(new GlobalCacheRelayModule(contactClosureConfig.moduleAddress, 3));
            }
        }
        for (const videoInputConfig of Object.values((_b = config.videoInputs) !== null && _b !== void 0 ? _b : {})) {
            const moduleAddress = parseInt((_c = videoInputConfig.code.split('_')[1]) !== null && _c !== void 0 ? _c : '1', 10);
            if (!newModules.some(m => m.address === moduleAddress)) {
                newModules.push(new GlobalCacheSwitchModule(moduleAddress, 3));
            }
        }
        const modulesChanged = newModules.length !== this.modules.length ||
            newModules.some(nm => !this.modules.some(m => m.address === nm.address));
        if (modulesChanged)
            this.modules = newModules;
        if (this.modules.length === 1)
            this.modules.push(new GlobalCacheRelayModule(1, 3));
    }
}
GlobalCache.emulatorType = 'socketEmulator';
GlobalCache.key = '-MqK-Sgk2f5J28Rwk_c1';
